// The public demo's Inertia 1 router resets null-state hash visits to the top
// and looks up percent-encoded Japanese IDs without decoding them. Keep public
// document anchors at their decoded target after that reset. Native links and
// browser history remain responsible for navigation, including Back/Forward.
export function initializePublicAnchors(root: Document = document) {
  const view = root.defaultView;
  if (!view) return () => {};

  function destination(hash: string) {
    if (!hash || hash === "#") return null;
    try { return root.getElementById(decodeURIComponent(hash.slice(1))); }
    catch { return null; }
  }

  let frame: number | undefined;
  const hashchange = () => {
    if (frame !== undefined) view.cancelAnimationFrame(frame);
    // Run after the island router's popstate scroll restoration, including Back.
    frame = view.requestAnimationFrame(() => {
      frame = view.requestAnimationFrame(() => destination(view.location.hash)?.scrollIntoView());
    });
  };

  view.addEventListener("hashchange", hashchange);
  return () => {
    view.removeEventListener("hashchange", hashchange);
    if (frame !== undefined) view.cancelAnimationFrame(frame);
  };
}
